package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.roster.AvailabilityDayDto
import com.evoapps.evoshift.data.dto.roster.AvailabilityStatusDto
import com.evoapps.evoshift.data.dto.roster.HoursRangeDto
import com.evoapps.evoshift.data.dto.roster.SharedAvailabilityDayDto
import com.evoapps.evoshift.domain.model.AvailabilityDay
import com.evoapps.evoshift.domain.model.HoursRange
import com.evoapps.evoshift.domain.model.AvailabilityStatus
import com.evoapps.evoshift.domain.model.DayPreference

class AvailabilityDayMapper {

    fun toDomain(dto: AvailabilityDayDto): DayPreference {
        return DayPreference(
            status = when (dto.status) {
                AvailabilityStatusDto.AVAILABLE -> AvailabilityStatus.AVAILABLE
                AvailabilityStatusDto.UNAVAILABLE -> AvailabilityStatus.UNAVAILABLE
            },
            preferredSlotId = dto.prefSlotId,
            comment = dto.comment,
            hours = dto.hours.map { HoursRange(it.start, it.end) }
        )
    }

    fun toDto(domain: DayPreference): AvailabilityDayDto {
        return AvailabilityDayDto(
            status = when (domain.status) {
                AvailabilityStatus.AVAILABLE -> AvailabilityStatusDto.AVAILABLE
                AvailabilityStatus.UNAVAILABLE -> AvailabilityStatusDto.UNAVAILABLE
            },
            prefSlotId = domain.preferredSlotId,
            comment = domain.comment,
            hours = domain.hours.map { HoursRangeDto(it.start, it.end) }
        )
    }

    fun toDomain(dto: SharedAvailabilityDayDto): AvailabilityDay = AvailabilityDay(
        status = if (dto.status == AvailabilityStatusDto.UNAVAILABLE) AvailabilityStatus.UNAVAILABLE else AvailabilityStatus.AVAILABLE,
        ranges = dto.ranges.map { HoursRange(it.start, it.end) },
        preferred = dto.preferred.map { HoursRange(it.start, it.end) },
        comment = dto.comment,
        workplaceComments = dto.workplaceComments
    )

    fun toDto(domain: AvailabilityDay): SharedAvailabilityDayDto = SharedAvailabilityDayDto(
        status = if (domain.status == AvailabilityStatus.UNAVAILABLE) AvailabilityStatusDto.UNAVAILABLE else AvailabilityStatusDto.AVAILABLE,
        ranges = domain.ranges.map { HoursRangeDto(it.start, it.end) },
        preferred = domain.preferred.map { HoursRangeDto(it.start, it.end) },
        comment = domain.comment,
        workplaceComments = domain.workplaceComments
    )
}
